export default "__VITE_ASSET__0cf16f84__"